import { useState, useEffect, useContext } from 'react';
import { useForm } from '../../hooks';

import {
  Typography,
  Button,
  Grid,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import StyledModal from './StyledModal';
import { TextField, CustomInput } from '../common';
import colors from '../../assets/colors';
import { agriculturalMachines } from '../../utils/api';
import FarmContext from '../../store/farm-context';

export default function AddMachineModal(props) {
  const [types, setTypes] = useState();
  const farmCTX = useContext(FarmContext);

  const handleClose = () => props.setOpen(false);
  const handleAddMachine = () => {
    addMachine();
    handleClose();
  };

  const { handleChange, values } = useForm({
    additionalInformation: '',
    brand: '',
    model: '',
    productionYear: 0,
    type: '',
  });

  const addMachine = () => {
    const body = {
      additionalInformation: values.additionalInformation,
      brand: values.brand,
      model: values.model,
      productionYear: values.productionYear,
      type: values.type,
    };
    agriculturalMachines
      .add(farmCTX.farmID, body)
      .then(() => props.updateMachines());
  };

  useEffect(() => {
    agriculturalMachines.types().then((result) => {
      setTypes(result.data);
    });
  }, [props.open]);

  return (
    <StyledModal open={props.open}>
      <IconButton
        onClick={handleClose}
        sx={{
          color: colors.redButton,
          position: 'absolute',
          top: 5,
          right: 5,
        }}
      >
        <CancelIcon />
      </IconButton>
      <Grid container justifyContent="center">
        <Typography sx={{ fontSize: 36, fontWeight: 500, mb: 4, mt: 1 }}>
          Dodaj maszynę
        </Typography>
      </Grid>
      <Grid container direction={'column'}>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField modal label="Marka" onChange={handleChange('brand')} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField modal label="Model" onChange={handleChange('model')} />
          </Grid>
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <FormControl fullWidth>
              <InputLabel>Typ maszyny</InputLabel>
              <Select
                aria-label="select button"
                label="Typ maszyny"
                input={<CustomInput />}
                defaultValue=""
                sx={{
                  textAlign: 'left',
                  borderRadius: '4px',
                  maxWidth: 275,
                }}
                onChange={handleChange('type')}
              >
                {types?.map((type, index) => (
                  <MenuItem value={type} key={index}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start', mt: 1 }}
          >
            <TextField
              modal
              label="Rok produkcji"
              type="number"
              onChange={handleChange('productionYear')}
            />
          </Grid>
        </Grid>
        <Grid container>
          <TextField
            modal
            label="Dodatkowe informacje o maszynie"
            fullWidth
            onChange={handleChange('additionalInformation')}
          />
        </Grid>
        <Grid
          container
          justifyContent="right"
          alignContent="right"
          alignItems="right"
        >
          <Button
            type="submit"
            variant="outlined"
            onClick={handleAddMachine}
            sx={{ mt: 2 }}
          >
            Zapisz zmiany
          </Button>
        </Grid>
      </Grid>
    </StyledModal>
  );
}
